// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timecode-input {
    width: 100%;
    height: 100%;
    box-sizing: border-box;

    display: flex;
    align-items: center;
    justify-content: center;

    background: #000;
    color: #d8d8d8;

    border: 1px solid transparent;
    outline: none;
    border-color: #303030;
    border-radius: 3px;

    cursor: text;
    -webkit-user-select: none;
            user-select: none;

    font-family: monospace;
    font-size: 16px;
}

.timecode-input-focused {
    border-color: white;
}

.timecode-input-invalid {
    color: #ff3333;
}

.timecode-value {
    white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/appmediaassets/submenudialogs/timecodeinput/timecodeinput.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;;IAEtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB,gBAAgB;IAChB,cAAc;;IAEd,6BAA6B;IAC7B,aAAa;IACb,qBAAqB;IACrB,kBAAkB;;IAElB,YAAY;IACZ,yBAAiB;YAAjB,iBAAiB;;IAEjB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".timecode-input {\n    width: 100%;\n    height: 100%;\n    box-sizing: border-box;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    background: #000;\n    color: #d8d8d8;\n\n    border: 1px solid transparent;\n    outline: none;\n    border-color: #303030;\n    border-radius: 3px;\n\n    cursor: text;\n    user-select: none;\n\n    font-family: monospace;\n    font-size: 16px;\n}\n\n.timecode-input-focused {\n    border-color: white;\n}\n\n.timecode-input-invalid {\n    color: #ff3333;\n}\n\n.timecode-value {\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
